import {
  RailwayOrderStatus,
  SeatClass
} from '@link/china-railway/services/types';

export default {
  common: {
    colon: ': ',
    cancel: 'キャンセル',
    confirm: '確認'
  },
  date: {
    month: {
      month1: '1月',
      month2: '2月',
      month3: '3月',
      month4: '4月',
      month5: '5月',
      month6: '6月',
      month7: '7月',
      month8: '8月',
      month9: '9月',
      month10: '10月',
      month11: '11月',
      month12: '12月'
    },
    weeks: {
      sun: '日',
      mon: '月',
      tue: '火',
      wed: '水',
      thu: '木',
      fri: '金',
      sat: '土'
    }
  },
  seatClass: {
    [SeatClass.Business]: 'ビジネスクラス',
    [SeatClass.Premium]: '特等席',
    [SeatClass.First]: 'ファーストクラス',
    [SeatClass.Second]: 'セカンドクラス'
  },
  confirmBooking: {
    title: 'ご確認',
    description: '予約確定後、変更はできません。以下の情報をご確認ください：',
    preOrderDescription:
      '予約確定後、15日前に【注文詳細】ページでチケットの状況をご確認ください。メールやSMSでの結果通知はありません。',
    departTime: '出発時刻',
    trainNumber: '列車番号',
    seatNumber: '車両/座席番号',
    autoAssign: '自動割り当て',
    passengerName: '予約者名',
    ticketCount: '予約枚数',
    confirmBook: '予約確定',
    date: '{{month}}月{{day}}日',
    orderSuccess: '予約成功',
    orderFailed: '予約失敗, 後でもう一度お試しください'
  },
  views: {
    booking: {
      bookingId: '注文 {{id}}'
    },
    railway: {
      details: '注文詳細',
      booking: '高速鉄道予約',
      ticketCount: 'チケット数',
      selectDate: '乗車日を選択',
      moreTime: 'もっと見る',
      bookTicket: '列車を予約',
      status: {
        [RailwayOrderStatus.StatusUnspecified]: '不明なステータス',
        [RailwayOrderStatus.Reserved]: '発券処理中、しばらくお待ちください',
        [RailwayOrderStatus.Booked]: '発券処理中、しばらくお待ちください',
        [RailwayOrderStatus.Cancelling]: 'キャンセル中',
        [RailwayOrderStatus.Cancelled]: 'キャンセル済み',
        [RailwayOrderStatus.Closed]: '残席不足、再度ご予約ください',
        [RailwayOrderStatus.Issuing]: '発券処理中、しばらくお待ちください',
        [RailwayOrderStatus.Issued]: '予約成功、発券完了',
        [RailwayOrderStatus.Used]: '利用済み'
      },
      usageDate: '使用日'
    },
    trainList: {
      book: '予約',
      preBook: '事前予約',
      noTrains: 'この時間帯には列車がありません',
      hour: '時間',
      minute: '分',
      durationFormat: '{{hours}}時間{{minutes}}分',
      ticketsLeft: '残り{{count}}枚',
      noTickets: 'チケット売り切れ',
      notOnSale: '発売前'
    },
    orderDetail: {
      title: '注文詳細',
      faq: 'よくある質問',
      dateTimeFormat: '{{year}}年{{month}}月{{day}}日 {{time}}',
      travelInfo: '旅行情報',
      departureTime: '出発時刻',
      trainNumber: '列車番号',
      seatNumber: '車両/座席番号',
      passengerName: '予約者名',
      ticketCount: '予約枚数',
      highSpeedTicket: '高速鉄道チケット',
      orderId: '注文ID',
      orderTime: '注文完了時間',
      rebookTicket: '再予約',
      preOrderStatus: '予約済み、{{days}}日後に発売開始',
      saleDate: '発売日',
      saleDateFormat: '{{year}}年{{month}}月{{day}}日',
      cancelOrder: '注文をキャンセル',
      cancelOrderSuccess: '注文のキャンセルが完了しました',
      cancelOrderFailed: 'キャンセルに失敗しました。後でもう一度お試しください',
      cancelOrderDialog: {
        title: '注文をキャンセルしますか',
        content: 'キャンセル後、再予約が可能です',
        confirm: 'キャンセル確定',
        cancel: 'キャンセルしない'
      }
    }
  }
};
